module.exports = __webpack_public_path__ + "static/media/line_sensors.51438001.jpg";